/* eslint-disable no-param-reassign */
import ganttProTextEditor from './text/textCellEditor';
import ganttProDateEditor from './date/dateCellEditor';
import ganttProDurationEditor from './duration/durationCellEditor';
import ganttProEstimationEditor from './estimation/estimationCellEditor';
import ganttProStatusEditor from './status/statusCellEditor';
import priorityCellEditor from './priority/priorityCellEditor';
import progressCellEditor from './progress/progressCellEditor';
import customColumnCellEditor from './customColumn/customColumnCellEditor';
import resourcesCellEditor from './resources/resourcesCellEditor';
import timeTrackingCellEditor from './timeTracking/timeTrackingCellEditor';
import GridPredecessorsCellEditor from './predecessors/predecessorsCellEditor';
import actualCostCellEditor from './costs/actualCostCellEditor';
import totalPriceCellEditor from './costs/totalPriceCellEditor';

const EDITORS = {
  duration: {
    type: 'ganttProDuration',
    map_to: 'auto',
  },
  estimation: {
    type: 'ganttProEstimation',
    map_to: 'auto',
  },
  text: {
    type: 'ganttProText',
    map_to: 'auto',
  },
  status: {
    type: 'ganttProStatus',
    map_to: 'status',
  },
  priority: {
    type: 'ganttProPriority',
    map_to: 'priority',
  },
  progress: {
    type: 'ganttProProgress',
    map_to: 'auto',
  },
  resource_id: {
    type: 'ganttProResources',
    map_to: 'auto',
  },
  time_tracking: {
    type: 'ganttProTimeTracking',
    map_to: 'time_tracking',
  },
  start_date: {
    type: 'ganttProStartDate',
    map_to: 'auto',
  },
  end_date: {
    type: 'ganttProEndDate',
    map_to: 'auto',
  },
  predecessors: {
    type: 'ganttProPredecessors',
    map_to: 'auto',
  },
  custom_column: {
    type: 'ganttProCustomColumn',
    map_to: 'auto',
  },
  actual_cost: {
    type: 'ganttProActualCost',
    map_to: 'auto',
  },
  total_price: {
    type: 'ganttProTotalPrice',
    map_to: 'auto',
  },
};

const GridColumnsEditors = {
  init(instance, projectConfig) {
    this.initEditorTypes(instance);
    this.applyEditorsToColumns(instance);
  },
  initEditorTypes(instance) {
    instance.config.editor_types.ganttProText = ganttProTextEditor(instance);
    // instance.config.editor_types.ganttProDate = ganttProDateEditor(instance);
    instance.config.editor_types.ganttProDuration = ganttProDurationEditor(instance);
    instance.config.editor_types.ganttProEstimation = ganttProEstimationEditor(instance);
    instance.config.editor_types.ganttProStatus = ganttProStatusEditor(instance);
    instance.config.editor_types.ganttProPriority = priorityCellEditor(instance);
    instance.config.editor_types.ganttProProgress = progressCellEditor(instance);
    instance.config.editor_types.ganttProResources = resourcesCellEditor(instance);
    instance.config.editor_types.ganttProTimeTracking = timeTrackingCellEditor(instance);
    instance.config.editor_types.ganttProStartDate = ganttProDateEditor(instance);
    instance.config.editor_types.ganttProEndDate = ganttProDateEditor(instance);
    instance.config.editor_types.ganttProPredecessors = GridPredecessorsCellEditor(instance);
    instance.config.editor_types.ganttProCustomColumn = customColumnCellEditor(instance);
    instance.config.editor_types.ganttProActualCost = actualCostCellEditor(instance);
    instance.config.editor_types.ganttProTotalPrice = totalPriceCellEditor(instance);
  },
  applyEditorsToColumns(instance) {
    const columns = instance.getGridColumns();

    columns.forEach(column => {
      const editor = column.isUserCustomColumn ? EDITORS.custom_column : EDITORS[column.name];

      if (editor) {
        column.editor = column.isUserCustomColumn ? EDITORS.custom_column : EDITORS[column.name];
      }
    });
  },
};

export default GridColumnsEditors;
